import { Component, OnInit } from '@angular/core';
import { TemplateService } from '@app/services/template.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-template-form',
  templateUrl: './template-form.component.html',
  styleUrls: ['./template-form.component.scss']
})
export class TemplateFormComponent implements OnInit {
  shortcode = '';
  description = '';
  templates: any[] = [];
  selectedTemplate: string = '';
  useExistingProperties = false;
  MTPropertyArr = '[]';
  isEditMode = false;
  finalPropertyArr: any[] = [];

  constructor(private templateService: TemplateService, private router: Router) { }

  ngOnInit() {
    this.templateService.getTemplateList().subscribe(data => this.templates = data);

    const navigation = history.state;
    if (navigation && navigation.editTemplate) {
      const editTemplate = navigation.editTemplate;
      this.isEditMode = true;
      this.shortcode = editTemplate.MTShortCode;
      this.description = editTemplate.MTDescription;
      this.MTPropertyArr = editTemplate.MTPropertyArr || '[]';
      this.useExistingProperties = true;
    }
  }

  save() {
    if (this.useExistingProperties && !this.isEditMode && this.selectedTemplate) {
      this.templateService.getTemplateWithSC(this.selectedTemplate).subscribe({
        next: (template) => {
          this.finalPropertyArr = this.parsePropertyArr(template?.MTPropertyArr);
          this.persistTemplate();
        },
        error: () => {
          this.finalPropertyArr = [];
          this.persistTemplate();
        },
      });
      return;
    }

    if (this.useExistingProperties && this.isEditMode) {
      this.finalPropertyArr = this.parsePropertyArr(this.MTPropertyArr);
    } else {
      this.finalPropertyArr = [];
    }
    this.persistTemplate();
  }

  private parsePropertyArr(raw: unknown): any[] {
    if (Array.isArray(raw)) return [...raw];
    if (raw == null || raw === '') return [];
    if (typeof raw === 'string') {
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  }

  private persistTemplate(): void {
    const newTemplate = {
      MTShortCode: this.shortcode,
      MTDescription: this.description,
      MTPropertyArr: Array.isArray(this.finalPropertyArr) ? this.finalPropertyArr : [],
    };
    this.templateService.saveTemplate(newTemplate).subscribe(() => {
      this.router.navigate(['/designer/template-list']);
    });
  }
}
